module.exports = __webpack_public_path__ + "media/images/story/top/point_image_4-ba6f5629700874b04dab3f7734435889.jpg";